import React, { useState } from 'react';
import { Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmationCentered from 'src/components/common/ConfirmationCentered';
import styles from '../ConfigModal.module.less';

const { Option } = Select;

type PropsExcludeApps = {
  generalErrorCodes: string[];
  errorCodes: string[];
  onChangeErrorCodes: (errorCodes: string[]) => void;
};

export const ExcludeApps: React.FC<PropsExcludeApps> = ({ generalErrorCodes, errorCodes, onChangeErrorCodes }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className={styles.subItem}>
        <label className={styles.subText}>Error Codes</label>
        <Select className={styles.subInput} mode="multiple" value={errorCodes} onChange={onChangeErrorCodes}>
          {generalErrorCodes.map((el) => {
            return (
              <Option value={el} key={el}>
                {el}
              </Option>
            );
          })}
        </Select>
        <FontAwesomeIcon icon={['fal', 'trash-alt']} onClick={() => setIsModalOpen(true)} className={styles.icon} />
      </div>
      <ConfirmationCentered
        title={'Are you sure you want to remove All Error Codes'}
        visible={isModalOpen}
        onAction={() => onChangeErrorCodes([])}
        setVisible={setIsModalOpen}
      />
    </>
  );
};
